import React from 'react';
import closeIcon from '@/assets/svg/close_icon.svg';

interface ModalCloseButtonProps {
    onClick: () => void;
    className?: string;
}

export const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({
    onClick,
    className = '',
}) => {
    return (
        <button
            className={`modal-close-button ${className}`}
            onClick={onClick}
            aria-label="Fermer"
        >
            <img src={closeIcon} alt="Fermer" />
        </button>
    );
};

